import { render, staticRenderFns } from "./WelcomeToRCDModal.vue?vue&type=template&id=72779771&lang=pug&"
import script from "./WelcomeToRCDModal.vue?vue&type=script&lang=js&"
export * from "./WelcomeToRCDModal.vue?vue&type=script&lang=js&"
import style0 from "./WelcomeToRCDModal.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports